// extracted by mini-css-extract-plugin
export default {"container":"Bootstrap_container__6UsSv"};